export const PostActionType = {
  GET_POST_FULFILLED: 'GET_POST_FULFILLED',
  DELETE_POST_FULFILLED: 'DELETE_USER_FULFILLED',
};
